module.exports = __webpack_public_path__ + "static/media/checked.178bd8ed.svg";